import { RefObject, useEffect, useState } from 'react';

export const useIsOnScreen = (
  ref: RefObject<HTMLElement>,
  opts: { rootMargin?: string; root?: HTMLElement } = {},
): boolean => {
  const [isIntersecting, setIntersecting] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(entry.isIntersecting),
      opts,
    );
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, [opts.root]);

  return isIntersecting;
};
